import { useMemo } from "react";

import classnames from "classnames";

import { Link, Text } from "components/ui/source";

import { Amenity } from "types/graphql";

import IconText from "../../IconText";
import { iconForAmenity } from "../amenityIcons";

import styles from "./TopAmenities.module.scss";

interface TopAmenitiesProps {
  amenities: Amenity[];
  amenityCount?: number;
  onSeeAll?: () => void;
  className?: string;
}

export default function TopAmenities({
  className,
  amenities,
  amenityCount = 4,
  onSeeAll,
}: TopAmenitiesProps) {
  const amenityElements = useMemo(
    () =>
      amenities
        .filter(amenity => amenity.active)
        .slice(0, amenityCount)
        .map((amenity, i) => (
          <div key={amenity.name + i} data-testid="top-amenity-element">
            <IconText
              Icon={iconForAmenity(amenity.name)}
              title={amenity.label}
              titleTextProps={{ className: styles.title }}
            />
          </div>
        )),
    [amenities, amenityCount],
  );

  if (!amenities || amenities.length == 0) return null;

  return (
    <div className={classnames(className, styles.container)}>
      <Text
        className={styles.feature_title}
        types={["caption1"]}
        translateKey="listing:intro.amenities"
      />
      {amenityElements}
      <Link
        textElement="span"
        textTypes={["caption1", "underline"]}
        translateKey="listing:intro.seeAllAmenities"
        onClick={onSeeAll}
        inline
        underline
      />
    </div>
  );
}
